/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim4CrossDiagIcon24Regular = forwardRef('ArrowDim4CrossDiagIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M14.25 3a.75.75 0 0 1 .75-.75h4.75a2 2 0 0 1 2 2V9a.75.75 0 0 1-1.5 0V4.81L13.06 12l7.19 7.19V15a.75.75 0 0 1 1.5 0v4.75a2 2 0 0 1-2 2H15a.75.75 0 0 1 0-1.5h4.19L12 13.06l-7.19 7.19H9a.75.75 0 0 1 0 1.5H4.25a2 2 0 0 1-2-2V15a.75.75 0 0 1 1.5 0v4.19L10.94 12 3.75 4.81V9a.75.75 0 0 1-1.5 0V4.25a2 2 0 0 1 2-2H9a.75.75 0 0 1 0 1.5H4.81L12 10.94l7.19-7.19H15a.75.75 0 0 1-.75-.75Z" })));
});
